<script>
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import { getNumber, toMoney } from '@utils/Format'
import Color from '@constants/Color'
import { FONT_FAMILY } from '@constants/Styles'

export default {
  props: {
    // Lista de valores com a liquidez.
    values: {
      type: Array,
      default: () => {
        return []
      },
    },
    // Apresentar ou nao o grafico de donut.
    showChart: {
      type: Boolean,
      default: true,
    },
    // Tamanho do grafico de donut.
    size: {
      type: Number,
      default: 400,
    },
    // Centralizar verticalmente ou nao o texto da legenda.
    centerText: {
      type: Boolean,
      default: true,
    },
    showPL: {
      type: Boolean,
    },
  },
  data() {
    return {
      Color,
      getNumber,
      chartOpts: {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: function(value) {
              return toMoney(value)
            },
          },
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: '80%',
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  offsetY: -15,
                  formatter: (v) => {
                    return toMoney(v)
                  },
                },
                total: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  show: true,
                  formatter: (w) => {
                    return toMoney(
                      w.globals.seriesTotals.reduce((a, b) => {
                        return a + b
                      }, 0)
                    )
                  },
                },
              },
            },
          },
        },
      },
    }
  },
  computed: {
    formatOpts() {
      return {
        ...this.chartOpts,
        labels: this.values.map((item) => {
          return item.name
        }),
        colors: Color.paleta,
      }
    },
    formatData() {
      return this.values.map((item) => {
        return getNumber(item.pl)
      })
    },
  },
}
</script>

<template>
  <div
    class="d-flex justify-content-center"
    :class="{ 'align-items-center': centerText }"
  >
    <!-- style="min-width: 25%; max-width: 50%;" -->
    <div
      v-if="showChart"
      style="width: 50%;"
      class="d-flex align-items-center justify-content-center"
    >
      <apexchart
        v-if="size"
        type="donut"
        :height="size"
        :width="size"
        :options="formatOpts"
        :series="formatData"
      >
      </apexchart>
      <apexchart
        v-if="!size"
        type="donut"
        :options="formatOpts"
        :series="formatData"
      >
      </apexchart>
    </div>
    <div
      class="d-flex flex-column"
      :class="{ 'justify-content-center': centerText }"
      style="min-width: 30%;"
    >
      <!-- style="width: 50%;" -->
      <v-simple-table
        dense
        style="background: transparent; width: 100%;"
        class="tabela-liquidez"
      >
        <template>
          <tbody>
            <template v-for="(liq, i) in values">
              <tr v-if="getNumber(liq.pl)" :key="liq.name" class="mb-1">
                <td>
                  <div class="d-flex align-items-center">
                    <v-sheet
                      v-if="showChart"
                      height="20"
                      width="5"
                      :style="{ 'background-color': Color.paleta[i] }"
                    ></v-sheet>
                    <p class="ml-1 mr-5 mb-0">
                      {{ liq.name }}
                    </p>
                  </div>
                </td>
                <td>
                  <p class="text-bold mb-0 mr-2 text-right">
                    <span v-if="showPL" class="text-color-400 mr-2"> {{ liq.pl }} </span>
                    {{ liq.weight }}
                  </p>
                </td>
                <!-- <td>
                  <p class="mb-0">
                    <small> ({{ liq.pl }}) </small>
                  </p>
                </td> -->
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<style lang="sass" scope>
.tabela-liquidez
  tr td
    border: none !important
    padding: 0 !important
    text-align: left !important
    white-space: nowrap
</style>
